import React, { useState, useEffect } from 'react';
import { FilterMarket } from '../../../components/Admin/Market';
import { MarketAPI } from '../../../api';
import { size } from 'lodash';
import { TableMarket } from '../../../components/Admin/Market';
import { useAuth } from '../../../hooks';
//import './MarketPage.scss';

const marketController = new MarketAPI();

export function MarketPage() {

  const [selectMarket, setSelectMarket] = useState(undefined);
  const [selectNetwork, setSelectNetwork] = useState(undefined);
  const [selectMembership, setSelectMembership] = useState(undefined);
  const [markets, setMarkets] = useState(null);
  const [reload, setReload] = useState(false);
  const { accessToken } = useAuth();

  useEffect(() => {
    (async () => {
      try {
        const response = await marketController.getMarkets(accessToken);
        setMarkets(response);
      } catch (error) {
        console.log(error);
      }
    })();
  }, [reload]);

  if(size(markets) === 0) return <p>not results</p>;

  // recargar la table
  const onReload = () => setReload((prevState) => !prevState);

  const handleSelectMarket = (e) => {
    console.log(e.target.value);
    setSelectMarket(e.target.value);
  }

  const handleSelectNetwork = (e) => {
    console.log(e.target.value);
    setSelectNetwork(e.target.value);
  }

  const handleSelectMembership = (e) => {
    console.log(e.target.value);
    setSelectMembership(e.target.value);
  }

  return (
      <>
        <FilterMarket 
          selectedMarket={handleSelectMarket}
          selectedNetwork={handleSelectNetwork}
          selectedMember={handleSelectMembership}
        />
        <TableMarket 
          markets={markets} 
          onReload={onReload} 
          selectMarket={selectMarket} 
          selectNetwork={selectNetwork} 
          selectMembership={selectMembership} 
        />
      
      </>
    );
}